<template>
  <div class="calendar-container">
    <div class="calendar-head">
      <span>{{ currentCalendarMonthText }}</span>
      <div class="month-peaker">
        <div @click="PreviousMonth()" class="previous btn">
          <svg
            width="7"
            height="14"
            viewBox="0 0 7 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.18863 13.8507C6.37424 14.0498 6.67518 14.0498 6.86079 13.8507C7.0464 13.6515 7.0464 13.3287 6.86079 13.1295L0.811367 6.63944C0.625756 6.44031 0.32482 6.44031 0.139209 6.63944C-0.0464029 6.83857 -0.0464029 7.16143 0.139209 7.36056L6.18863 13.8507Z"
              fill="#908F8D"
            />
            <path
              d="M0.139209 6.63944C-0.0464029 6.83857 -0.0464029 7.16143 0.139209 7.36056C0.32482 7.55969 0.625756 7.55969 0.811367 7.36056L6.86079 0.87047C7.0464 0.671338 7.0464 0.348481 6.86079 0.149349C6.67518 -0.049783 6.37424 -0.049783 6.18863 0.149349L0.139209 6.63944Z"
              fill="#908F8D"
            />
          </svg>
        </div>
        <div class="day-indicator">{{ formatGroupDate(currentDate) }}</div>
        <div @click="NextMonth()" class="next btn">
          <svg
            width="7"
            height="14"
            viewBox="0 0 7 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.811367 13.8507C0.625756 14.0498 0.32482 14.0498 0.139209 13.8507C-0.0464028 13.6515 -0.0464028 13.3287 0.139209 13.1295L6.18863 6.63944C6.37424 6.44031 6.67518 6.44031 6.86079 6.63944C7.0464 6.83857 7.0464 7.16143 6.86079 7.36056L0.811367 13.8507Z"
              fill="#908F8D"
            />
            <path
              d="M6.86079 6.63944C7.0464 6.83857 7.0464 7.16143 6.86079 7.36056C6.67518 7.55969 6.37424 7.55969 6.18863 7.36056L0.139209 0.87047C-0.0464028 0.671338 -0.0464028 0.348481 0.139209 0.149349C0.32482 -0.049783 0.625755 -0.049783 0.811367 0.149349L6.86079 6.63944Z"
              fill="#908F8D"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="calendar-body">
      <div class="day-header">
        <div class="day-name" v-for="day in dayNames" :key="day">{{ day }}</div>
      </div>
      <div class="dates">
        <div
          :class="[
            'day-date',
            areDatesSame(new Date(), date, 'day') ? 'today-date' : '',
            areDatesSame(currentDate, date, 'day') ? 'selected-date' : '',
            areDatesSame(currentDate, date, 'month') ? 'selected-month' : '',
          ]"
          @click="changeCurrentDate(date)"
          v-for="(date,index) in calendar"
          :key="index"
        >
          <!-- {{ date.split("/")[1] }} -->
          {{ formatCalendarEntry(date) }}
          <div v-if="isReservetDay(date)" class="is-reserved-indicator"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    reservationDates: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      currentDate: new Date(),
      calendar: [],
      dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    };
  },
  methods: {
    isReservetDay(date) {
      for (let i = 0; i < this.reservationDates.length; i++) {
        if (moment(this.reservationDates[i]).isSame(date, "day")) {
          return true;
        }
      }
      return false;
    },
    emitDateChange() {
      this.$emit("onDateSelect", this.currentDate);
    },
    PreviousMonth() {
      this.renderCalendar(
        moment(this.currentDate).subtract(1, 'month')
      );
      this.emitDateChange();
    },
    NextMonth() {
      this.renderCalendar(
        moment(this.currentDate).add(1, 'month')
      );
      this.emitDateChange();
    },
    renderCalendar(target_date) {
      this.calendar = [];
      this.currentDate = moment(target_date).toDate();

      const month_start = moment(target_date).startOf('month').startOf('day');
      const month_end = moment(target_date).endOf('month').endOf('day');

      if (month_start.day() != 0) {
        for (let i = 1; i < month_start.day(); i++) {
          this.calendar.push(
            moment(month_start).subtract(i, 'days').toDate()
          );
        }
      }

      let ptr = moment(month_start);

      while (ptr.isSameOrBefore(month_end)) {
        this.calendar.push(ptr.toDate());
        ptr = ptr.add(1, 'day');
      }

      if (month_end.day() > 0) {
        const remainder = 7 - this.calendar.length % 7;
        for (let i = 1; i <= remainder; i++) {
          this.calendar.push(
            moment(month_end).add(i, 'days').toDate()
          );
        }
      }

      this.emitDateChange();
    },
    changeCurrentDate(date) {
      if (this.areDatesSame(this.currentDate, date, "month")) {
        this.currentDate = date;
      }

      this.emitDateChange();
    },
    formatGroupDate(raw) {
      const now = moment();
      const then = moment(raw);

      if (now.isSame(then, "day")) return this.$t('reserve_calendar.today');
      if (moment(now).subtract(1, "day").isSame(then, "day")) return this.$t('reserve_calendar.yesterday');
      if (now.add(1, "day").isSame(then, "day")) return this.$t('reserve_calendar.tomorrow');

      return then.format("DD");
    },
    areDatesSame(date1, date2, type) {
      return moment(date1).isSame(moment(date2), type);
    },
    formatCalendarEntry(v) {
      return moment(v).format('D');
    }
  },
  computed: {
    currentCalendarMonthText() {
      return moment(this.currentDate).format('MMMM YYYY');
    }
  },
  created() {
    let day_ptr = moment().startOf('week').day(1);
    this.dayNames = [];
    for (let i = 0; i < 7; i++) { 
      this.dayNames.push(
        day_ptr.format('ddd')
      );
      day_ptr.add(1, 'day');
    }

    this.renderCalendar(
      new Date()
    );
  },
};
</script>
<style scoped>
.calendar-container {
  width: 100%;
  padding-bottom: 3.571428571428571vh;
  background-color: #464646;
}
.calendar-head {
  width: 100%;
  color: #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.231527093596059vh 2.463054187192118vh 0;
  font-size: 1.8472906403940885vh;
  line-height: 2.0935960591133003vh;
}
.month-peaker {
  display: flex;
}
.btn {
  width: 6.2807881773399vh;
  height: 2.7093596059113296vh;
  color: #908f8d;
  background-color: #1d1d1b;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.day-indicator {
  width: 8.743842364532018vh;
  height: 2.7093596059113296vh;
  font-size: 1.4778325123152707vh;
  line-height: 1.7241379310344827vh;
  background-color: #1d1d1b;
  margin: 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn.previous {
  border-radius: 0.61vh 0 0 0.61vh;
}
.btn.next {
  border-radius: 0 0.61vh 0.61vh 0;
}
.btn svg {
  width: 0.8620689655172413vh;
  height: 1.7241379310344827vh;
}
.dates {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 0 4.3vh 0 2.1vh;
}
.day-date {
  position: relative;
  cursor: pointer;
  color: #908f8d;
  font-size: 1.8472906403940885vh;
  line-height: 8vw;
  width: 8vw;
  height: 8vw;
  display: flex;
  align-content: center;
  justify-content: center;
  margin-left: 3.733vw;
  margin-bottom: 1.8472906403940885vh;
}
div.today-date {
  color: #e2223b !important;
}
div.selected-date {
  background: #ededed;
  color: #464646;
  border-radius: 50%;
}
.selected-month {
  color: #ededed;
}
.day-header {
  display: flex;
  padding: 0 4vh 0 2.1vh;
  justify-content: space-between;
}
.day-name {
  color: #908f8d;
  width: 8vw;
  height: 8vw;
  font-size: 1.8472906403940885vh;
  line-height: 8vw;
  text-align: center;
  margin-left: 3.733vw;
}
.is-reserved-indicator {
  position: absolute;
  background: #e2223b;
  border-radius: 0.36945812807881767vh;
  top: 0;
  right: 0;
  width: 0.7389162561576353vh;
  height: 0.7389162561576353vh;
}
@media screen and (min-width: 765px) {
  .day-date {
    width: 2.083vw;
    height: 2.083vw;
    padding: 0.417vw;
    margin: 0 1.042vw 1.042vw 0;
    font-size: 1.042vw;
    line-height: 1.042vw;
  }
  .day-name {
    width: 2.083vw;
    height: 2.083vw;
    font-size: 1.042vw;
    line-height: 1.181vw;
    margin: 0 1.55vw 0 0;
  }
  .dates {
    width: 22.667vw;
    margin: 0 auto 0;
    padding: 0;
    font-size: 1.042vw;
    line-height: 1.181vw;
  }
  .calendar-head {
    padding: 1.389vw 5.486vw 0;
    font-size: 1.042vw;
    line-height: 1.181vw;
  }
  .day-indicator {
    width: 4.931vw;
    height: 1.528vw;
  }
  .btn {
    width: 3.542vw;
    height: 1.528vw;
  }
  .btn svg {
    width: 0.486vw;
    height: 0.972vw;
  }
  .day-header {
    width: 22vw;
    margin: 0.694vw 0 1.042vw;
    margin-left: 5.5vw;
    padding: 0.417vw 0 0.486vw;
    height: 2.083vw;
    align-content: center;
  }
  .is-reserved-indicator {
    width: 0.417vw;
    height: 0.417vw;
  }
}
</style>